import React from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

const Pricing = () => {
    const { session, user } = useAuth();

    const handleSubscribe = async (variantId) => {
        if (!session) {
            alert('Please sign in to subscribe');
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/payments/checkout`,
                { variantId },
                { headers: { Authorization: `Bearer ${session}` } }
            );
            if (response.data.checkoutUrl) {
                window.location.href = response.data.checkoutUrl;
            }
        } catch (error) {
            console.error('Checkout failed:', error);
            alert('Failed to start checkout. Please try again.');
        }
    };

    const plans = [
        {
            name: 'Starter',
            price: '$19',
            variantId: 'starter_variant_id', // Placeholder
            features: ['Unlimited Workflows', 'Basic AI Generation', '1 Collaborator']
        },
        {
            name: 'Pro',
            price: '$49',
            variantId: 'pro_variant_id', // Placeholder
            features: ['Priority AI Support', 'Unlimited Collaborators', 'Advanced Analytics', 'Admin Panel Access'],
            highlight: true
        }
    ];

    return (
        <div className="py-20 bg-dark-bg text-dark-text-primary">
            <div className="max-w-6xl mx-auto px-4 text-center">
                <h2 className="text-4xl font-bold mb-4">Simple, Transparent Pricing</h2>
                <p className="text-dark-text-secondary mb-12">Choose the plan that's right for your business.</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    {plans.map((plan) => (
                        <div
                            key={plan.name}
                            className={`p-8 rounded-2xl border ${plan.highlight ? 'border-brand-primary bg-dark-surface ring-2 ring-brand-primary' : 'border-dark-border bg-dark-bg'} flex flex-col`}
                        >
                            <h3 className="text-2xl font-bold mb-2">{plan.name}</h3>
                            <div className="text-4xl font-bold mb-6">{plan.price}<span className="text-lg font-normal text-dark-text-secondary">/mo</span></div>

                            <ul className="mb-8 space-y-4 text-left flex-grow">
                                {plan.features.map(feature => (
                                    <li key={feature} className="flex items-center">
                                        <svg className="w-5 h-5 text-emerald-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                        {feature}
                                    </li>
                                ))}
                            </ul>

                            <button
                                onClick={() => handleSubscribe(plan.variantId)}
                                className={`w-full py-3 rounded-lg font-semibold transition ${plan.highlight ? 'bg-brand-primary hover:bg-brand-secondary text-white' : 'bg-dark-border hover:bg-gray-700'}`}
                            >
                                {user?.token ? 'Get Started' : 'Sign in to Subscribe'}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Pricing;
